<template>
  <div class="home">
    <ArticleMarqueeComponent
      v-if="!skipQuery"
      :locale="locale"
      :country="country"
    />
    <AdvertComponent
      v-if="!skipQuery"
      :country="country"
      :advert="advert"
      ad-slot="site_leaderboard"
    />
    <HeroVideoComponent v-if="heroVideo" :video="heroVideo" />
    
    <!--
    <div class="firework-emebed container">
      <fw-embed-feed
        channel="bandwagon"
        playlist="ojGAKg"
        mode="row"
        open_in="default"
        max_videos="0"
        placement="middle"
        player_placement="bottom-right"
        autoplay="true"
        size="large"
        branding="false"
      ></fw-embed-feed>
    </div>
    -->
    
    <div class="background-embed">
      <div class="content-embed">
        <p>Latest on Instagram</p>
      </div>
      <div class='embedsocial-story-gallery' data-ref="c5b13c24fa59c602892cea8912e21407b2c5baa3"></div>
    </div>

    <div class="article-blocks home__section container">
      <ArticleBlockComponent
        v-for="(article, index) in featuredArticles"
        :key="article.slug"
        :fixed-style="
          article.homePageLayout ? article.homePageLayout : blockStyles[index]
        "
        :article="article"
      />
    </div>

    <div class="newsletter__form--large">
      <NewsletterForm
        v-if="!skipQuery"
        :country-newsletter-id="countryNewsletterId"
        :locale="locale"
      />
    </div>

    <ArticleVideosComponent
      v-if="!skipQuery"
      :country="country"
      :locale="locale"
      :article-videos-url="articleVideosUrl"
    />
    
    <!-- <div class="firework-emebed container">
      <h2>Stories</h2>
      <fw-embed-feed
        channel="bandwagon"
        playlist="o9dxd5"
        mode="row"
        open_in="default"
        max_videos="0"
        placement="middle"
        player_placement="bottom-right"
        branding="false"
        size="large"
      ></fw-embed-feed>
    </div> -->

    <HappeningComponent :country="country" :gigsUrl="gigsUrl" />
    <ArticleGuideComponent
      :country="country"
      :locale="locale"
      :guidesUrl="guidesUrl"
    />
    <div class="article-blocks home__section container">
      <div class="home__header">
        <h1>{{ $t("categories.reviews") }}</h1>
        <hr class="divider" />
      </div>
      <ArticleBlockComponent
        v-for="(article, index) in featuredReviews"
        :key="article.slug"
        :fixed-style="guideBlockStyles[index]"
        :article="article"
      />
      <a class="article-blocks__view-more" :href="reviewsUrl">{{
        $t("buttons.view-more-reviews")
      }}</a>
    </div>
    <div class="background--gray">
      <WatchNowComponent
        v-if="!skipQuery"
        :locale="locale"
        :country="country"
      />
    </div>
  </div>
</template>

<script>
import AdvertComponent from "../advert/AdvertComponent.vue";
import ArticleBlockComponent from "../article/ArticleBlockComponent.vue";
import ArticleGuideComponent from "../article/ArticleGuideComponent.vue";
import ArticleMarqueeComponent from "../article/ArticleMarqueeComponent.vue";
import ArticleVideosComponent from "./ArticleVideosComponent.vue";
import HappeningComponent from "./HappeningComponent.vue";
import WatchNowComponent from "./WatchNowComponent.vue";
import ShopComponent from "../shop/ShopComponent.vue";
import HeroVideoComponent from "./HeroVideoComponent.vue";
import NewsletterForm from "../shared/NewsletterForm.vue";
import gql from "graphql-tag";

export default {
  components: {
    AdvertComponent,
    ArticleBlockComponent,
    ArticleGuideComponent,
    ArticleMarqueeComponent,
    ArticleVideosComponent,
    HappeningComponent,
    WatchNowComponent,
    ShopComponent,
    HeroVideoComponent,
    NewsletterForm,
  },
  props: {
    blockStyles: {
      type: Array,
      default: () => [
        "two-thirds",
        "third",
        "third",
        "third",
        "third",
      ],
    },
    guideBlockStyles: {
      type: Array,
      default: () => ["full", "full", "full"],
    },
    gigsUrl: {
      type: String,
      default: "#",
    },
    reviewsUrl: {
      type: String,
      default: "#",
    },
    guidesUrl: {
      type: String,
      default: "#",
    },
    articleVideosUrl: {
      type: String,
      default: "#",
    },
    advert: {
      type: Object,
      default: () => ({}),
    },
    heroVideo: {
      type: Object,
      default: () => ({}),
    },
  },
  apollo: {
    information: {
      query: gql`
        query visitorInformation {
          visitorInformation {
            country
            locale
            countryNewsletterId
          }
        }
      `,
      update(data) {
        this.country = data.visitorInformation.country;
        this.locale = data.visitorInformation.locale;
        this.countryNewsletterId = data.visitorInformation.countryNewsletterId;
        return data.visitorInformation;
      },
    },
    featuredArticles: {
      query: gql`
        query featuredArticles($country: String!, $locale: String!) {
          featuredArticles(limit: 5, country: $country, locale: $locale) {
            homePageImage
            title
            slug
            author
            homePageLayout
            spins
            genre
            url
            isPaid
            titleInCountry(country: $country)
            languageInCountry(country: $country)
            categories {
              name
              slug
            }
          }
        }
      `,
      variables() {
        return {
          country: this.country,
          locale: this.locale,
        };
      },
      skip() {
        return this.skipQuery;
      },
    },
    featuredReviews: {
      query: gql`
        query featuredReviews($country: String!, $locale: String!) {
          featuredArticles(
            type: "review"
            country: $country
            locale: $locale
            limit: 3
          ) {
            homePageLayout
            homePageImage
            title
            slug
            url
            author
            spins
            genre
            titleInCountry(country: $country)
            languageInCountry(country: $country)
          }
        }
      `,
      variables() {
        return {
          country: this.country,
          locale: this.locale,
        };
      },
      update(data) {
        return data.featuredArticles;
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
  data() {
    return {
      skipQuery: true,
      country: null,
      locale: "en",
      countryNewsletterId: "c04c8e2b7e",
      featuredArticles: [],
      featuredReviews: [],
    };
  },
  mounted() {
    this.loadScriptEmbedFeed();
  },
  methods: {
    loadScriptEmbedFeed() {
      const script = document.createElement('script');
      script.type = "text/javascript";
      script.async = true;
      script.src = `https://asset.fwcdn3.com/js/embed-feed.js?timestamp=${new Date().getTime()}`;
      document.head.appendChild(script);
    },
    featuredArticlesQuery() {
      this.$apollo.queries.featuredArticles.refetch();
    },
    featuredReviewsQuery() {
      this.$apollo.queries.featuredReviews.refetch();
    },

    clickIframeButton(direction) {
      const iframe = this.$refs.embedIframe;
      if (iframe && iframe.contentWindow) {
        const iframeDocument = iframe.contentWindow.document;
        let button;
        if (direction === 'prev') {
          button = iframeDocument.querySelector('.swiper-div-prev-gallery'); // Thay '.iframe-prev-button' bằng selector của nút "prev" trong iframe
        } else if (direction === 'next') {
          button = iframeDocument.querySelector('.swiper-div-next-gallery'); // Thay '.iframe-next-button' bằng selector của nút "next" trong iframe
        }
        if (button) {
          button.click();
        }
      }
    },
  },
  watch: {
    country(val, oldVal) {
      if (oldVal == null && val != null) {
        this.skipQuery = false;
        this.featuredArticlesQuery();
        this.featuredReviewsQuery();
      }
    },
  },
};
</script>
